if (!window.hasOwnProperty('appModules')) {
    window.appModules = {};
}

window.appModules.BookConstructorLanding = function () {
    var self = this;
    var templates = {
        bookTypes: $('#book-types-template').html()
    };

    var data = {};
    self.REVERSAL_BINDING_ID = 1;
    self.PAGE_BINDING_ID = 2;
    var templateGroupId = 0;
    var templateCategoryId = 0;
    var formatId = 0;
    var typeId = 0;
    var isCreate = false;

    function init() {
        $.get(window.requestUrls.init, function (response) {
            if (response.hasOwnProperty('errors')) {
                alert(response.error);
                return false;
            }

            data = response;

            var hash = window.location.hash.split('#').join('');
            switch (hash) {
                case 'types':
                    self.showContainer(hash);
                    templateGroupId = 0;
                    templateCategoryId = 0;
                    renderTypes();
                    break;
                case 'main':
                    self.showContainer(hash);
                    break;
            }
        }, 'json');
    }

    function createProject() {
        var name = $('#js-project-name').val();
        addProject({ name: name, book_types: typeId, formats: formatId, group_id: templateGroupId });
    }

    function addProject(data) {
        if (isCreate) {
            return;
        }

        isCreate = true;
        self.request.post(window.requestUrls.add, data, function (response) {
            isCreate = false;
            if (response.hasOwnProperty('error')) {
                alert(response.error.description);
                return false;
            }

            if (response.hasOwnProperty('project')) {
                window.location = window.requestUrls.edit + response.project.id + '_' + response.project.hash;
            }
        }, 'json');
    }

    function previewTemplate(id) {
        $.get(window.requestUrls.preview + id, function (response) {
            var templateData = {
                version: Math.random(),
                images: {
                    hardcover: response.images.hardcover,
                    reversals: []
                },
                template_id: response.template_id,
                height: response.height
            };

            for (var i in response.images.reversals) {
                templateData.images.reversals.push(response.images.reversals[i]);
            }

            self.dialog.show('bc_preview_template', templateData);
        }, 'json');
    }

    self.showContainer = function (name) {
        $('.page').addClass('invisible');
        $('#' + name).removeClass('invisible');
        window.location.hash = name;
    };

    function renderTypes() {
        var templateData = {
            types: []
        };

        var allowFormats = [];
        if (templateGroupId !== 0) {
            for (var i in data.templates[templateCategoryId][templateGroupId]) {
                var template = data.templates[templateCategoryId][templateGroupId][i];
                allowFormats.push(String(template.format_id));
            }
        }

        for (var typeId in data.book_price) {
            if (!data.book_types.hasOwnProperty(typeId)) {
                continue;
            }

            var item = {
                id: typeId,
                name: data.book_types[typeId].name,
                print: data.book_types[typeId].print,
                hardcover: data.book_types[typeId].hardcover,
                description: data.book_types[typeId].description,
                minValue: data.reversals[typeId].min_value,
                maxValue: data.reversals[typeId].max_value,
                formats: [],
                isPageType: parseInt(data.book_types[typeId].binding_id) === self.PAGE_BINDING_ID ? true : false,
                isImage: parseInt(data.reversals[typeId].image) === 1 ? true : false,
                companyId: data.reversals[typeId].company_id,
                coverName: Yii.t('Not specified'),
                paperName: Yii.t('Not specified'),
                deadline: data.reversals[typeId].deadline
            };

            if (data.min_price.covers.hasOwnProperty(typeId)) {
                item.coverName = data.min_price.covers[typeId].name;
            }

            if (data.min_price.papers.hasOwnProperty(typeId)) {
                item.paperName = data.min_price.papers[typeId].name;
            }

            var formats = data.book_price[typeId];
            for (var formatId in formats) {
                if (allowFormats.length > 0 && allowFormats.indexOf(formatId) === -1) {
                    continue;
                }

                if (!data.book_formats.hasOwnProperty(formatId)) {
                    continue;
                }

                var itemFormat = {
                    id: formatId,
                    typeId: typeId,
                    name: data.book_formats[formatId].name,
                    width: data.book_formats[formatId].width,
                    height: data.book_formats[formatId].height,
                    isImage: parseInt(data.book_formats[formatId].image) === 1 ? true : false,
                    count: 0,
                    cost: 0,
                    pageCost: 0
                };

                if (templateGroupId === 0) {
                    itemFormat.count = data.reversals[typeId].min_value;
                } else {
                    itemFormat.count = data.templates[templateCategoryId][templateGroupId][0].count_reversals;
                }

                if (
                    data.min_price.papers.hasOwnProperty(typeId)
                    && data.min_price.papers[typeId].prices.hasOwnProperty(formatId)
                    && data.min_price.covers.hasOwnProperty(typeId)
                    && data.min_price.covers[typeId].prices.hasOwnProperty(formatId)
                ) {
                    itemFormat.cost += parseFloat(data.min_price.papers[typeId].prices[formatId]) * itemFormat.count;
                    itemFormat.cost += parseFloat(data.min_price.covers[typeId].prices[formatId]);
                }

                if (
                    data.min_price.papers.hasOwnProperty(typeId)
                    && data.min_price.papers[typeId].prices.hasOwnProperty(formatId)
                ) {
                    itemFormat.pageCost += parseFloat(data.min_price.papers[typeId].prices[formatId]);
                }

                if (
                    data.min_price.flyleafs.hasOwnProperty(typeId)
                    && data.min_price.flyleafs[typeId].prices.hasOwnProperty(formatId)
                ) {
                    itemFormat.cost += parseFloat(data.min_price.flyleafs[typeId].prices[formatId]);
                }

                itemFormat.cost = itemFormat.cost.toFixed(2);
                itemFormat.pageCost = itemFormat.pageCost.toFixed(2);

                item.formats.push(itemFormat);

                item.formats.sort(function (a, b) {
                    return a.name >= b.name ? 1 : -1;
                });
            }

            if (item.formats.length === 0) {
                continue;
            }

            templateData.types.push(item);
        }

        var html = self.templater.render(templates.bookTypes, templateData);
        $('#book-types').html(html);
    }

    function get(hash) {
        app.request.get(window.requestUrls.getProject, function (response) {
            app.dialog.show('book_project', response);
        }, 'json');
    }

    function copy(sid) {
        app.dialog.show('bc_copy_project', { sid: sid });
    }

    function remove(el) {
        if (confirm(Yii.t('Are you sure you want to delete the photobook project?'))) {
            var sid = el.parents('.project').attr('data-sid');
            app.request.post(window.requestUrls.remove + sid, function (response) {
                if (response.hasOwnProperty('error')) {
                    alert(response.error.description);
                } else {
                    el.parents('.project').remove();
                }
            }, 'json');
        }
    }

    // for youtube video
    function labnolThumb(id) {
        return '<img class="youtube-thumb" src="//i.ytimg.com/vi/' + id + '/sddefault.jpg" width="480" height="360"><div class="play-button"></div>';
    }

    // for youtube video
    function labnolIframe() {
        var iframe = document.createElement("iframe");
        iframe.setAttribute("src", "//www.youtube.com/embed/" + this.parentNode.dataset.id + "?autoplay=1&autohide=2&border=0&wmode=opaque&enablejsapi=1&controls=0&showinfo=0");
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("id", "youtube-iframe");
        this.parentNode.replaceChild(iframe, this);
    }

    // youtube video
    function labnolInit() {
        var v = document.getElementsByClassName("youtube-player");
        for (var n = 0; n < v.length; n++) {
            var p = document.createElement("div");
            p.innerHTML = labnolThumb(v[n].dataset.id);
            p.onclick = labnolIframe;
            v[n].appendChild(p);
        }
    }

    init();
    labnolInit();

    $(document).on('click', '.js-show-types', function (e) {
        self.dialog.hide('bc_projects');
        self.showContainer('types');
        templateGroupId = 0;
        templateCategoryId = 0;
        renderTypes();
    });

    $(document).on('click', '.type-hide', function (e) {
        self.showContainer('main');
    });

    $(document).on('click', '.js-set-format', function () {
        typeId = $(this).attr('data-type');
        formatId = $(this).attr('data-format');
        app.dialog.show('bc_create_project');
    });

    $(document).on('click', '.js-set-template', function () {
        self.showContainer('types');
        templateGroupId = $(this).attr('data-id');
        templateCategoryId = $(this).attr('data-category');
        renderTypes();
    });

    $(document).on('click', '.js-show-templates', function (e) {
        self.showContainer('templates');
    });

    $(document).on('click', '.js-preview-template', function () {
        previewTemplate($(this).attr('data-id'));
    });

    $(document).on('click', '.js-create-project', function () {
        createProject();
    });

    $('.project-remove').on('click', function () {
        remove($(this));
    });

    $('.project-prop').on('click', function () {
        var hash = $(this).parents('.project').attr('data-sid');
        get(hash);
    });

    $('.project-copy').on('click', function () {
        var sid = $(this).parents('.project').attr('data-sid');
        copy(sid);
    });

    $('.project-edit').on('click', function () {
        var sid = $(this).parents('.project').attr('data-sid');
        window.location = window.requestUrls.edit + sid;
    });
};

if (window.hasOwnProperty('app')) {
    app.initModule('constructor', window.appModules.BookConstructorLanding);
}
